var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.77 1H2.23C1.55 1 1 1.554 1 2.23v7.383c0 .68.555 1.23 1.23 1.23h11.54c.674 0 1.23-.547 1.23-1.23V2.23C15 1.555 14.452 1 13.77 1Zm-.173.82L8.87 6.523c-.232.232-.541.36-.87.36-.329 0-.638-.128-.87-.361L2.402 1.82h11.194ZM1.82 9.446V2.398l3.545 3.526L1.82 9.446Zm.583.577 3.544-3.52.603.6c.387.387.902.6 1.45.6.548 0 1.063-.213 1.45-.6l.603-.6 3.544 3.52H2.403Zm11.777-.577-3.545-3.522 3.545-3.526v7.048Z",
    fill: "var(--native-icon-fill)",
    stroke: "var(--native-icon-fill)",
    strokeWidth: 0.5
  })));
};

export default SvgEmail;